module.exports = __webpack_public_path__ + "img/step8-c.1d0e89a5.png";